import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        author: 'impony'
    },
    getters: {
        authorName: function (state) {
            return state.author;
        }
    },
    mutations: {
        changeName: function (state, payload) {
            state.author = payload.author;
        }
    },
    actions: {
        actionChangeName: function (context, payload) {
            context.commit('changeName', payload);
        }
    }
})
